import { types, actions } from './requests'
export const DELETELOT_TYPES = {
    ...types('DELETELOT'),
}
export const DELETELOT_ACTIONS = {
    ...actions('DELETELOT'),
}